module.exports = __webpack_public_path__ + "static/sample_STRIDE_PC-7094f7611dcc1a48871b60e92001a7f7.png";